module.exports = __webpack_public_path__ + "media/burgir.c7445f56.mp3";